
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkEventInvitationDeclinedStatusEnum } from '../models/work-event-invitation-declined-status-enum';
import { WorkEventInvitationExamResultEnum } from '../models/work-event-invitation-exam-result-enum';
import { WorkUpdateEventRegistrationSelectedOptionDto } from '../models/work-update-event-registration-selected-option-dto';

export function getUpdateEventInvitationV2DtoFormGroup() {
return new FormGroup({
    eventId: new FormControl<number | undefined>(undefined),
    audienceId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    gender: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    company: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    email: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    accept: new FormControl<boolean | undefined>(undefined),
    checkInAt: new FormControl<string | undefined>(undefined),
    comment: new FormControl<string | undefined>(undefined),
    declinedStatus: new FormControl<WorkEventInvitationDeclinedStatusEnum | undefined>(undefined),
    examResult: new FormControl<WorkEventInvitationExamResultEnum | undefined>(undefined),
    eventInvitationTypeId: new FormControl<number | undefined>(undefined),
    eventRegistrationSelectedOptions: new FormControl<WorkUpdateEventRegistrationSelectedOptionDto[]>([]),
})
;
}
      